import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getProjectFirestopDetailAndProductItems = async (projectId) => {
  const apiPath = `firestop-documentation/project/${projectId}/firestop-detail-and-product-items`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
  });

  const response = await axios(signedRequest);

  return response.data;
};
